$(document).ready(function () {

    var isFirstInteraction = true;
    var currentScroll;

    // Accordion toggle function
    function toggleAccordion(accordionToggle) {
        var parentItem = accordionToggle.closest('.accordion-item');
        var content = parentItem.find('.accordion-body');
        var isOpen = accordionToggle.attr('aria-expanded') === 'true';

        // Find the image-container and figure in the parent item
        var imageContainer = parentItem.find('.image-container');
        var figure = parentItem.find('.accordion-header figure');

        if (isFirstInteraction) {
            currentScroll = $(window).scrollTop(); // Capture scroll position on first interaction
        }

        // Toggle accordion visibility
        if (isOpen) {
            accordionToggle.removeClass('show').attr('aria-expanded', 'false');
            content.slideUp(300).removeClass('show').attr('hidden', true);
            imageContainer.removeClass('show');
            figure.removeClass('show');
        } else {
            // Open selected accordion (without closing others)
            accordionToggle.addClass('show').attr('aria-expanded', 'true');
            content.slideDown(300).addClass('show').attr('hidden', false);
            imageContainer.addClass('show'); 
            figure.addClass('show');
        }

        if (isFirstInteraction) {
            $(window).scrollTop(currentScroll);
            isFirstInteraction = false;
        }
    }

    // Handle accordion clicks
    $(document).on('click', '.accordion-toggle', function () {
        toggleAccordion($(this));
    });

    // Open accordion based on URL hash
    function openAccordionFromHash() {
        var hash = window.location.hash;
        if (hash) {
            var target = $(hash);
            if (target.length) {
                var toggle = target.closest('.accordion-item').find('.accordion-toggle');

                // Open the specified accordion (without closing others)
                toggle.addClass('show').attr('aria-expanded', 'true');
                target.slideDown(300).addClass('show').attr('hidden', false);

                // Show the associated figure when opening from hash
                var figure = target.closest('.accordion-item').find('.accordion-header figure');
                figure.addClass('show');

                // Scroll to the accordion
                $('html, body').animate({
                    scrollTop: toggle.offset().top
                }, 500);
            }
        }
    }

    openAccordionFromHash();

    // Reopen accordion on hash change
    $(window).on('hashchange', function () {
        openAccordionFromHash();
    });

    // Accessibility: Allow 'Enter' or 'Space' to toggle accordion
    $(document).on('keydown', '.accordion-toggle', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).trigger('click');
        }
    });
});
